import React, { useState } from "react";
import { formatNoteStamp } from "./radarFormat";

// Private note thread + composer for the entry detail. TEMPLATE ORIGIN:
// components/scout-request/RadarNotesPanel.jsx — copied and stripped of ALL
// attribution: no author avatar, no author name/role pill, no club footer. These
// notes are personal ("only you can see these"), newest first. Presentational:
// the parent owns the notes array and the add call; this renders the composer and
// the thread and reports nothing but the typed text back through onAdd.
const RadarNotes = ({ notes = [], onAdd, mobile = false }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const add = async () => {
    const v = text.trim();
    if (!v || busy) return;
    setBusy(true);
    const res = await onAdd(v);
    setBusy(false);
    if (res?.success) setText("");
  };

  return (
    <div>
      <div className="flex" style={{ gap: mobile ? 8 : 7, marginBottom: 11 }}>
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder="Add a quick note…"
          maxLength={500}
          className="flex-1 min-w-0 outline-none"
          style={{ height: mobile ? 44 : 34, border: "1px solid #DDE3EB", borderRadius: 9, padding: `0 ${mobile ? 11 : 10}px`, fontSize: mobile ? 13.5 : 12.5 }}
        />
        <button
          type="button"
          onClick={add}
          disabled={busy || !text.trim()}
          className="bg-[#2283FF] hover:bg-[#1B6FE0] text-white border-none font-semibold cursor-pointer disabled:opacity-50"
          style={{ height: mobile ? 44 : 34, borderRadius: 9, padding: `0 ${mobile ? 16 : 14}px`, fontSize: mobile ? 13 : 12.5 }}
        >
          Add
        </button>
      </div>

      <div className="flex flex-col" style={{ gap: 7 }}>
        {notes.map((n) => (
          <div key={n.id} style={{ background: "#F8FAFC", border: "1px solid #EEF1F5", borderRadius: 9, padding: mobile ? "10px 12px" : "9px 11px" }}>
            <div className="text-[#374151] leading-[1.5]" style={{ fontSize: mobile ? 13 : 12.5 }}>{n.text}</div>
            <div className="text-[10.5px] text-[#9CA3AF]" style={{ marginTop: 4 }}>{formatNoteStamp(n.created_at)}</div>
          </div>
        ))}
        {notes.length === 0 && (
          <div className="text-[#9CA3AF]" style={{ fontSize: mobile ? 12.5 : 12, padding: mobile ? "2px 1px" : "4px 1px" }}>
            No notes yet — only you can see these.
          </div>
        )}
      </div>
    </div>
  );
};

export default RadarNotes;
